document.addEventListener('DOMContentLoaded', function () {
  // CUSTOM CURSOR
  const cursor = document.createElement('div');
  cursor.className = 'cursor';

  const cursorRing = document.createElement('div');
  cursorRing.className = 'cursor-ring';

  document.body.appendChild(cursor);
  document.body.appendChild(cursorRing);

  document.addEventListener('mousemove', function (e) {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';

    cursorRing.style.left = e.clientX + 'px';
    cursorRing.style.top = e.clientY + 'px';
  });

  document.querySelectorAll('a, button, .collection-card, .product-card').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      cursor.classList.add('cursor-hover');
      cursorRing.classList.add('cursor-hover');
    });

    el.addEventListener('mouseleave', function () {
      cursor.classList.remove('cursor-hover');
      cursorRing.classList.remove('cursor-hover');
    });
  });

  // REVEAL ANIMATIONS
  const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    {
      threshold: 0.15
    }
  );

  revealElements.forEach(function (el) {
    observer.observe(el);
  });
});
// ADD TO CART FEEDBACK

document.querySelectorAll('.product-add').forEach((button) => {

  button.addEventListener('click', () => {

    const original = button.innerHTML;

    button.classList.add('added');
    button.innerHTML = 'Ajouté';

    setTimeout(() => {
      button.classList.remove('added');
      button.innerHTML = original;
    }, 1800);

  });

});
// LOADER MARZENOS

window.addEventListener('DOMContentLoaded', function () {
  const loader = document.getElementById('marzenos-loader');

  if (!loader) return;

  setTimeout(function () {
    loader.classList.add('hidden');
  }, 1200);

  setTimeout(function () {
    loader.remove();
  }, 2800);
});
// PAGE TRANSITION

document.querySelectorAll('a').forEach(function (link) {

  link.addEventListener('click', function (e) {

    const href = link.getAttribute('href');

    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      link.target === '_blank' ||
      link.id === 'cart-icon-bubble' ||
      link.closest('#cart-icon-bubble') ||
      href.includes('/cart')
    ) {
      return;
    }

    const transition = document.getElementById('marzenos-page-transition');

    if (!transition) return;

    e.preventDefault();

    transition.classList.add('active');

    setTimeout(function () {
      window.location.href = href;
    }, 650);

  });

});
// PREMIUM CART TOAST

document.addEventListener('submit', function (e) {
  const form = e.target;

  if (!form || !form.action || !form.action.includes('/cart/add')) return;

  setTimeout(function () {
    let toast = document.querySelector('.marzenos-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'marzenos-toast';
      toast.innerHTML = `
        <span>Ajouté au panier</span>
        <small>Votre pièce a été ajoutée avec succès.</small>
      `;
      document.body.appendChild(toast);
    }

    toast.classList.add('active');

    setTimeout(function () {
      toast.classList.remove('active');
    }, 2600);
  }, 400);
});
// AJAX ADD TO CART MARZENOS - CART DRAWER + CART COUNT UPDATE

document.addEventListener('submit', function (e) {
  const form = e.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  e.preventDefault();

  const formData = new FormData(form);

  formData.append('sections', 'cart-drawer,cart-icon-bubble');
  formData.append('sections_url', window.location.pathname);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        const parser = new DOMParser();

        if (response.sections['cart-drawer']) {
          const newDrawer = parser
            .parseFromString(response.sections['cart-drawer'], 'text/html')
            .querySelector('cart-drawer');

          const currentDrawer = document.querySelector('cart-drawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            currentDrawer.classList.remove('is-empty');
          }
        }

        if (response.sections['cart-icon-bubble']) {
          const newBubble = parser
            .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
            .querySelector('#cart-icon-bubble');

          const currentBubble = document.querySelector('#cart-icon-bubble');

          if (newBubble && currentBubble) {
            currentBubble.outerHTML = newBubble.outerHTML;
          }
        }
      }

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartBubble =
            document.querySelector('.cart-count') ||
            document.querySelector('.cart-count-bubble span[aria-hidden="true"]');

          if (cartBubble) {
            cartBubble.textContent = cart.item_count;
          }
        });

      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        document.getElementById('cart-icon-bubble')?.click();
      }
    })
    .catch(error => {
      console.error('Erreur ajout panier:', error);
    });
});